import {
  IFormMultiChoiceOptionServer,
  IMultiChoiceFieldConfigurationClient,
  IMultiChoiceFieldConfigurationServer,
  IMultiChoiceFieldOptionsClient,
} from "./interface";

export const transformMultichoiceOptionServerToClient = (
  multiChoiceOptionsServer: IFormMultiChoiceOptionServer[]
) => {
  if (!multiChoiceOptionsServer) return;
  const multiChoiceOptionsClient: IMultiChoiceFieldOptionsClient[] = [];

  multiChoiceOptionsServer?.forEach(
    (multiChoiceOptionServer: IFormMultiChoiceOptionServer) => {
      const { key, value, initialValue } = multiChoiceOptionServer;

      const multiChoiceOptionClient = {
        optionKey: key,
        optionValue: value,
        initialValue
      } as IMultiChoiceFieldOptionsClient;

      multiChoiceOptionsClient.push(multiChoiceOptionClient);
    }
  );
  return multiChoiceOptionsClient;
};

export const transformMultichoiceOptionClientToServer = (
  multiChoiceOptionsClient: IMultiChoiceFieldOptionsClient[]
) => {
  if (!multiChoiceOptionsClient) return;
  const multiChoiceOptionsServer: IFormMultiChoiceOptionServer[] = [];

  multiChoiceOptionsClient?.forEach(
    (multiChoiceOptionClient: IMultiChoiceFieldOptionsClient) => {
      const { optionKey, optionValue, initialValue} = multiChoiceOptionClient;

      const multiChoiceOptionServer = {
        key: optionKey,
        value: optionValue,
        initialValue: initialValue,
      } as IFormMultiChoiceOptionServer;

      multiChoiceOptionsServer.push(multiChoiceOptionServer);
    }
  );

  return multiChoiceOptionsServer;
};

export const transformMultipleChoiceFieldConfigClientToServer = (
  fieldConfigClient: IMultiChoiceFieldConfigurationClient
): IMultiChoiceFieldConfigurationServer => {
  const { options, selectedType, alignDirection,writeJavascript } = fieldConfigClient;
  const fieldConfigServer = {
    options: transformMultichoiceOptionClientToServer(options),
    selectedType: { selected: selectedType },
    alignDirection: { selected: alignDirection },
    writeJavascript: writeJavascript,
  };
  return fieldConfigServer;
};

export const transformMultiChoiceConfigServerToClient = (
  fieldConfigServer: IMultiChoiceFieldConfigurationServer
): IMultiChoiceFieldConfigurationClient => {
  const { selectedType, alignDirection, options, writeJavascript } = fieldConfigServer;
  const fieldConfigClient = {
    options: transformMultichoiceOptionServerToClient(options),
    selectedType: selectedType?.selected,
    alignDirection: alignDirection?.selected,
    writeJavascript: writeJavascript,
  };
  return fieldConfigClient;
};
